export interface OAuth {
    clientId: string,
    redirectUri: string,
    responseType: string,
    scope: string,
    decision: string,
    state: string,
    codeChallenge?: string,
    codeChallengeMethod?: string
}

export interface OauthClientAppConfig {
    ou: string;
    clientId: string;
    redirectUri: string;
    responseType: string;
    scope: string;
    state: string;
    isPkceDisabled: boolean;
}

export interface AppConfig {
    ou: string;
    clientId: string;
    goto: string;

}

export interface LoginOidcRequest {

    templateId: string;
    ou: string;
    loginId: string;
    password: string;
    deviceProfile: {};
    oauth?: OAuth;

}

export interface LoginRequest {

    templateId: string;
    ou: string;
    clientId: string;
    loginId: string;
    password: string;
    deviceProfile: {};

}

export interface ChallengeVerificationOidcRequest {

    templateId: string;
    idpAuthJourneyStepId: string;
    type: string;
    value: string;
    trustDevice: boolean;
    oauth?: OAuth;

}

export interface ChallengeVerificationRequest {

    templateId: string;
    idpAuthJourneyStepId: string;
    type: string;
    value: string;
    trustDevice: boolean;
    clientId: string;

}

export interface ChallengeVerificationRequest {

    templateId: string;
    idpAuthJourneyStepId: string;
    clientId: string;
    type: string;
    value: string;
    trustDevice: boolean;

}

export interface OAuthResponse {
    data: {
        oauth: {
            code: string;
        }
    };
}

export interface NoContentResponse {
    status: number

}

export interface FailureContentResponse {
    status: number;
    data:{
        
    };
}

export interface Contact {
    "id": string,
    "mask": string,
    "type": 'EMAIL' | 'PHONE',
    "deliveryAttempts": number
}

export interface AuthenticationCallbackResponse {
    status: number;
    data: {
        idpAuthJourneyStepId: string;
        callbacks: [
            {
                type: 'ChallengeValidationCallback' | 'ChallengeGenerationCallback',
                output: {
                    "contact": Contact
                } | {
                    "contacts": Contact[],
                    deliveryAttemptsLimitPerChannel: number,
                    verifyAttemptsLimit: number,
                    failedAttempts: number,
                    isOtpExpired: boolean
                }

            }
        ]
    }

}

export const allowedOAuthErrors = {
    // AM error for consent requirement
    AuthenticationConsentRequired: 'Authentication or consent required',
    // Manual iframe error
    AuthorizationTimeout: 'Authorization timed out',
    // Chromium browser error
    FailedToFetch: 'Failed to fetch',
    // Mozilla browser error
    NetworkError: 'NetworkError when attempting to fetch resource.',
    // Webkit browser error
    CORSError: 'Cross-origin redirection',
};